import React from 'react';
import { CreatePage } from '@components/common';
import BorrowingForm from '@components/common/forms/BorrowingForm';

const BorrowingCreatePage = () => {
    return (
        <CreatePage
            modelName="borrowings"
            FormComponent={BorrowingForm}
        />
    );
};

export default BorrowingCreatePage;
